// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import {
  Box,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { AppBaseUrl, LinkedinBaseUrl } from "../../config/config";
import { certificationBadgeLink } from "../../config/constant";
import SharableLink from "../certificate/SharableLink";
import DocumentView from "../certificate/DocumentView";

const AwardsList = (props: { certificationData: readonly any[] }) => {
  const addToLinkedin = (certification: any) => {
    var url = `${LinkedinBaseUrl}?startTask=CERTIFICATION_NAME&name=${
      certification.name
    }&organizationId=66028&certUrl=${AppBaseUrl}/certificate/${
      certification.certificationId
    }&certId=${
      certification.certificationId
    }&issueYear=${certification.date?.substring(
      0,
      4
    )}&issueMonth=${certification.date?.substring(5, 7)}`;
    window.open(url, "_blank");
  };

  return (
    <Box sx={{ flexGrow: 1, p: 2, mt: 2 }}>
      <Grid container spacing={2}>
        {props.certificationData.map((certification, index) => (
          <Grid
            key={index}
            item
            {...{ xs: 12, sm: 6, md: 4, lg: 3 }}
            minHeight={160}
            sx={{
              textAlign: "center",
            }}
          >
            <Typography
              variant="body2"
              component="h2"
              sx={{ fontWeight: "bold", minHeight: 60, display: "inline" }}
            >
              {certification.position} {certification.region !== "NONE" && (" - " + certification?.region)}
            </Typography>

            <Grid 
              sx={{ marginTop: "1rem" }}>
              {certification.logo ? (
                <img
                  width={150}
                  src={certification.logo}
                  alt={certification.logo}
                />
              ) : (
                <img
                  width={150}
                  src={
                    certificationBadgeLink[
                      certification.name as keyof typeof certificationBadgeLink
                    ]
                  }
                />
              )}
            </Grid>
            <Stack
              direction="row"
              spacing={2}
              sx={{ marginTop: 2 }}
              justifyContent="center"
            >
              <DocumentView document={certification} documentType={certification.template} />
              <SharableLink certificationId={certification.certificationId + "/" + certification.id} award={certification}/>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AwardsList;
